(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vm-product"] && !Shopify.designMode) return;
  try {
    
const vmInit=(scope=document)=>scope.querySelectorAll('[data-vm-pdp]').forEach(root=>{
if(root.dataset.ready)return;root.dataset.ready='true';
const $=s=>root.querySelector(s),$$=s=>[...root.querySelectorAll(s)];
const labels=JSON.parse($('[data-labels]').textContent),allocations=JSON.parse($('[data-allocations]').textContent);
const money=v=>new Intl.NumberFormat(document.documentElement.lang||'en-US',{style:'currency',currency:root.dataset.currency||'USD'}).format(v/100);
const shopRoot=()=>(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
let selected,plan=null,price=0,slide=0;
function refresh(){
selected=$('.vm-pack input:checked')||$('.vm-pack input');if(!selected)return;
const available=allocations.find(v=>String(v.id)===selected.value)?.allocations||[];
if(plan===null)plan=available.length?String(available[0].selling_plan_id):'';
else if(plan&&!available.some(a=>String(a.selling_plan_id)===plan))plan=available.length?String(available[0].selling_plan_id):'';
$('[data-plans]').replaceChildren();
available.forEach(a=>{
const label=document.createElement('label');label.className='vm-purchase-option';const input=document.createElement('input');input.type='radio';input.name=$('.vm-purchase input[value=""]').name;input.value=String(a.selling_plan_id);input.checked=plan===input.value;
const span=document.createElement('span'),strong=document.createElement('strong'),small=document.createElement('small'),b=document.createElement('b');
const saving=Number(selected.dataset.price)-a.price;strong.textContent=saving>0?'Subscribe and save '+Math.round(saving/Number(selected.dataset.price)*100)+'%':'Subscribe, recurring delivery';small.textContent=(a.name||'Recurring delivery')+', cancel any time';span.append(strong,small);b.textContent=money(a.price);
if(saving>0){const del=document.createElement('del');del.textContent=money(Number(selected.dataset.price));b.append(del)}label.append(input,span,b);$('[data-plans]').append(label);input.addEventListener('change',()=>{plan=input.value;update()})});
$('.vm-purchase input[value=""]').checked=!plan;update();
}
function update(){
const count=Number(selected.dataset.count),a=allocations.find(v=>String(v.id)===selected.value)?.allocations.find(x=>String(x.selling_plan_id)===plan);price=a?.price??Number(selected.dataset.price);
const protection=$('[data-protection]').checked?500:0,total=price+protection;
$$('.vm-pack').forEach(p=>{const yes=p.contains(selected);p.classList.toggle('is-selected',yes);p.querySelector('input').setAttribute('aria-checked',String(yes))});
$$('.vm-pack').forEach(card=>{const input=card.querySelector('input');const base=Number(input.dataset.price);const offers=allocations.find(v=>String(v.id)===input.value)?.allocations||[];const allocation=offers.find(a=>String(a.selling_plan_id)===plan)||offers[0];const amount=plan&&allocation?allocation.price:base;card.querySelector('b').textContent=money(amount);card.querySelector('small').textContent=money(amount/Number(input.dataset.count))+' / bottle';});
$$('.vm-purchase-option').forEach(p=>p.classList.toggle('is-selected',p.querySelector('input').checked));
$('[data-total]').textContent=money(Number(selected.dataset.price));$('[data-button-price]').textContent=money(total);$('[data-sticky-detail]').textContent=count+' '+(count===1?'bottle':'bottles')+' · '+money(total);
$('[data-mystery]').classList.toggle('is-locked',count<5);$('[data-gift-status]').textContent=count>=5?labels.free:labels.locked;$('[data-gift-caption]').textContent=count>=5?labels.included:labels.unlock;$('[data-gift-progress]').textContent=count>=5?'Every extra is unlocked.':count>=3?'Add '+(5-count)+' more bottles to unlock the mystery extra.':'Choose 3 bottles to unlock the guide and free worldwide shipping.';
$('[data-ebook-gift]').classList.toggle('is-locked',count<3);$('[data-ebook-status]').textContent=count>=3?'FREE':'LOCKED';
$('[data-shipping-gift]').classList.toggle('is-locked',count<3);$('[data-shipping-status]').textContent=count>=3?'FREE':'LOCKED';$('[data-shipping-caption]').textContent=count>=3?'Worldwide shipping included':'Unlocks with 3 or 5 bottles';$('[data-gift-value]').textContent='Included gift value: '+money((count>=3?4400:0)+(count>=5?2900:0));
const enabled=root.dataset.launch==='true'&&root.dataset.preview!=='true',available=selected.dataset.available==='true';$('[data-add]').disabled=!enabled||!available;$('[data-add] span').textContent=!enabled?labels.coming:available?labels.add:labels.sold;
$('[name="id"]').value=selected.value;const sp=$('[name="selling_plan"]');sp.value=plan;sp.disabled=!plan;
if(enabled){const url=new URL(location.href);url.searchParams.set('variant',selected.value);history.replaceState({},'',url)}urgency();
}
function liveStock(){
const start=Number(root.dataset.confirmedStock)||0;if(start<=0)return 0;
const FLOOR=Math.max(5,Math.round(start*0.12)),STEP_MS=240000,KEY='vm_stock_'+start;
let s=null;try{s=JSON.parse(localStorage.getItem(KEY)||'null')}catch(e){}
if(!s||typeof s.t!=='number'||typeof s.v!=='number'||s.v>start){s={t:Date.now(),v:start};try{localStorage.setItem(KEY,JSON.stringify(s))}catch(e){}}
const dec=Math.floor((Date.now()-s.t)/STEP_MS);
return Math.max(FLOOR,s.v-dec);
}
function urgency(){const box=$('[data-urgency]'),inventory=Number(selected.dataset.inventory);box.hidden=true;
const confirmed=root.dataset.stockConfirmed==='true';let remaining=0,unit='packs';
if(confirmed){const live=liveStock();if(live>0){remaining=live;unit='bottles'}}
if(!remaining&&selected.dataset.tracked==='shopify'&&selected.dataset.policy==='deny'&&inventory>0&&inventory<=20){remaining=inventory}
if(remaining){box.hidden=false;$('[data-urgency-title]').textContent='Limited stock available';$('[data-urgency-detail]').textContent=remaining+' '+unit+' left';const batch=Number(root.dataset.batchSize);$('[data-stock-progress]').style.width=batch>=remaining&&batch>0?Math.max(4,remaining/batch*100)+'%':'100%';return}
const deadline=Date.parse(root.dataset.promoEnd);if(Number.isFinite(deadline)&&deadline>Date.now()){box.hidden=false;const sec=Math.floor((deadline-Date.now())/1000);$('[data-urgency-title]').textContent=labels.offer;$('[data-urgency-detail]').textContent=Math.floor(sec/86400)+'d '+Math.floor(sec%86400/3600)+'h '+Math.floor(sec%3600/60)+'m '+sec%60+'s'}
}
const drawer=$('[data-drawer]');
function openDrawer(){if(!drawer)return;drawer.hidden=false;drawer.setAttribute('aria-hidden','false');requestAnimationFrame(()=>drawer.classList.add('is-open'));document.body.style.overflow='hidden'}
function closeDrawer(){if(!drawer)return;drawer.classList.remove('is-open');drawer.setAttribute('aria-hidden','true');document.body.style.overflow='';setTimeout(()=>{drawer.hidden=true},300)}
async function renderDrawer(){
if(!drawer)return;
let cart;try{cart=await (await fetch(shopRoot()+'cart.js',{headers:{'Accept':'application/json'}})).json()}catch(e){return}
const wrap=$('[data-drawer-items]');wrap.replaceChildren();
if(!cart.items||!cart.items.length){const p=document.createElement('p');p.className='vm-drawer__empty';p.textContent='Your cart is empty.';wrap.append(p)}
(cart.items||[]).forEach(i=>{
const row=document.createElement('div');row.className='vm-drawer__item';
if(i.image){const img=document.createElement('img');img.src=i.image;img.alt='';img.loading='lazy';row.append(img)}
const mid=document.createElement('div');
const t=document.createElement('strong');t.textContent=i.product_title;mid.append(t);
const bits=[];if(i.variant_title&&i.variant_title!=='Default Title')bits.push(i.variant_title);bits.push('Qty '+i.quantity);
const v=document.createElement('small');v.textContent=bits.join(' · ');mid.append(v);
if(i.selling_plan_allocation&&i.selling_plan_allocation.selling_plan){const sp=document.createElement('small');sp.className='vm-drawer__sub';sp.textContent=i.selling_plan_allocation.selling_plan.name;mid.append(sp)}
const p=document.createElement('b');p.textContent=i.final_line_price===0?labels.free:money(i.final_line_price);
row.append(mid,p);wrap.append(row)});
$('[data-drawer-subtotal]').textContent=money(cart.total_price);
const hasSub=(cart.items||[]).some(i=>i.selling_plan_allocation);
$('[data-drawer-note]').textContent=hasSub?'Includes a recurring order. Shipping and tax calculated at checkout.':'Shipping and tax calculated at checkout.';
const badge=document.querySelector('.vm-cart-link span');if(badge)badge.textContent=cart.item_count;
}
$$('[data-drawer-close]').forEach(b=>b.addEventListener('click',closeDrawer));
document.addEventListener('keydown',e=>{if(e.key==='Escape'&&drawer&&!drawer.hidden)closeDrawer()});
$$('.vm-pack input').forEach(i=>i.addEventListener('change',refresh));$('.vm-purchase input[value=""]').addEventListener('change',()=>{plan='';update()});$('[data-protection]').addEventListener('change',update);
const initial=new URL(location.href).searchParams.get('variant');const matching=$$('.vm-pack input').find(x=>x.value===initial);if(matching)matching.checked=true;refresh();
const timer=setInterval(()=>{if(!root.isConnected){clearInterval(timer);return}urgency()},1000);
function showSlide(index){const slides=$$('.vm-gallery-slide');if(!slides.length)return;slide=(index+slides.length)%slides.length;slides.forEach((s,i)=>s.hidden=i!==slide);$$('[data-slide]').forEach((b,i)=>b.setAttribute('aria-pressed',String(i===slide)));const c=$('[data-gallery-counter]');if(c)c.textContent=(slide+1)+' / '+slides.length}
$$('[data-slide]').forEach(b=>b.addEventListener('click',()=>showSlide(Number(b.dataset.slide))));$$('[data-gallery-step]').forEach(b=>b.addEventListener('click',()=>showSlide(slide+Number(b.dataset.galleryStep))));showSlide(0);
let touchX=0;const stage=$('.vm-main-gallery');if(stage){stage.addEventListener('touchstart',e=>touchX=e.changedTouches[0].screenX,{passive:true});stage.addEventListener('touchend',e=>{const delta=e.changedTouches[0].screenX-touchX;if(Math.abs(delta)>50)showSlide(slide+(delta<0?1:-1))},{passive:true})}
const observer=new IntersectionObserver(es=>$('[data-sticky]').classList.toggle('is-visible',!es[0].isIntersecting&&es[0].boundingClientRect.bottom<0),{threshold:0});observer.observe($('.vm-buybox'));
const reviews=JSON.parse($('[data-reviews]').textContent);let shown=0;function more(){reviews.slice(shown,shown+10).forEach(r=>{const article=document.createElement('article');article.className='vm-review-card';const stars=document.createElement('p'),body=document.createElement('p'),by=document.createElement('small');stars.className='vm-review-stars';stars.textContent='★'.repeat(Math.round(Number(r.rating)||5));body.className='vm-review-body';body.textContent=r.body;by.className='vm-review-by';by.textContent=[r.author,'In-store review'].filter(Boolean).join(' · ');article.append(stars,body,by);$('[data-review-list]').append(article)});shown+=10;$('[data-more-reviews]').hidden=shown>=reviews.length;$('[data-review-empty]').hidden=reviews.length>0}more();$('[data-more-reviews]').addEventListener('click',more);
$('[data-vm-form]').addEventListener('submit',async e=>{e.preventDefault();if($('[data-add]').disabled)return;$('[data-add]').disabled=true;$('[data-error]').textContent='';try{const item={id:Number(selected.value),quantity:1};if(plan)item.selling_plan=Number(plan);const items=[item];if($('[data-protection]').checked)items.push({id:Number(root.dataset.protectionId),quantity:1});if(root.dataset.giftsEnabled==='true'&&Number(selected.dataset.count)>=3){items.push({id:53837608026405,quantity:1});if(Number(selected.dataset.count)>=5)items.push({id:53837608190245,quantity:1})}const response=await fetch(shopRoot()+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});const result=await response.json();if(!response.ok)throw new Error(result.description||labels.error);$('[data-add]').disabled=false}catch(e){$('[data-error]').textContent=e.message||labels.error;$('[data-add]').disabled=false}});
});vmInit();document.addEventListener('shopify:section:load',e=>vmInit(e.target));

  } catch(e) { console.error(e); }
})();
})();
